export enum DocumentFileType {
  PDF = 'PDF',
  Image = 'Image',
  Unsupported = 'Unsupported'
}
